var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarsicon = function SvgStarsicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.993.065a.32.32 0 0 0-.5.167l-.348 1.214a1.6 1.6 0 0 1-1.099 1.1l-1.214.346a.32.32 0 0 0 0 .616l1.214.347a1.6 1.6 0 0 1 1.1 1.099l.346 1.214a.32.32 0 0 0 .616 0l.347-1.214a1.6 1.6 0 0 1 1.099-1.1l1.214-.346a.32.32 0 0 0 0-.616l-1.214-.346s-.5-.215-.692-.408a1.6 1.6 0 0 1-.407-.692L13.108.232a.32.32 0 0 0-.115-.167ZM6.785 3.329a.64.64 0 0 0-1 .335L5.09 6.093A3.2 3.2 0 0 1 2.893 8.29l-2.43.694a.64.64 0 0 0 0 1.23l2.43.694a3.2 3.2 0 0 1 2.198 2.199l.694 2.428a.64.64 0 0 0 1.23 0l.694-2.428a3.2 3.2 0 0 1 2.198-2.199l2.43-.694a.64.64 0 0 0 0-1.23l-2.43-.694s-.999-.43-1.384-.814a3.2 3.2 0 0 1-.814-1.384l-.694-2.429a.64.64 0 0 0-.23-.335Z",
    clipRule: "evenodd"
  })));
};
export default SvgStarsicon;